import { defineComponent } from "vue";

export default defineComponent({
  props: {
    title: { type: String, required: true },
    address: { type: String, required: true },
    phone: { type: String, required: true },
    phonelink: { type: String, required: true },
    email: { type: String, required: true },
  },
});
